(ns frontend.view.nev.surveys.form.status-template
    (:require
     [clojure.edn :as edn]
     [clojure.string :as string]
     [common.localization :as loc]
     [common.schema.entities.survey.survey-reference-periods :as survey-reference-periods]
     [common.schema.entities.survey.survey-template :as survey-template-schema]
     [common.util :as cu]
     [frontend.view.nev.surveys.form.components :as components]
     [frontend.view.nev.surveys.form.events :as events]
     [frontend.view.nev.surveys.form.sub :as sub]
     [re-frame.core :as rf]
     [ui.editors.labelled-input.view :as labelled-input]))

(defn template-selector
  [survey-process template-options]
  [:<>
   [:div
    [labelled-input/view
     {:label       (loc/tr :survey-process/template)
      :editor-type :editor.type/select
      :value       (->> template-options
                        (cu/filter-by :value (:survey-process/template survey-process))
                        (first))
      :options     template-options
      :on-change   #(rf/dispatch [::events/set-template %])}]]])

(defn lang-selector
  [survey-process language-options]
  [labelled-input/view
   {:label       (loc/tr :survey-process/language)
    :editor-type :editor.type/select
    :value       (->> language-options
                      (cu/filter-by :value (:survey-process/language survey-process))
                      (first))
    :placeholder (loc/tr :select-language)
    :options     (->> language-options
                      (map (fn [opt]
                             (assoc opt :value (pr-str (:value opt)))))
                      (sort-by :label))
    :on-change   (fn [v]
                   (rf/dispatch [::events/set-language (edn/read-string v)]))}])

(defn ref-period-selector
  [survey-process template]
  (js/console.log "TEMPLATE : " template)
  (let [period-type (get-in template [:survey-template/config :reference-period] :reference-period/year)
        options (survey-reference-periods/period-options period-type)
        selected-value (str (:survey-process/timestamp-period-start survey-process)
                            "-"
                            (:survey-process/timestamp-period-end survey-process))]
    [labelled-input/view
     {:label       (loc/tr :reference-period)
      :editor-type :editor.type/select
      :value       (->> options
                        (cu/filter-by :value selected-value)
                        (first))
      :options     options
      :on-change   (fn [v]
                     (let [[start-ts-str end-ts-str] (string/split v "-")
                           start-ts (edn/read-string start-ts-str)
                           end-ts (edn/read-string end-ts-str)]
                       (rf/dispatch [::events/set-ref-period start-ts end-ts])))}]))

(defn label-input
  [languages survey-process]
  [:div
   {:class "pt-3"}
   [:div
    {:class "pb-1.5 flex gap-2 items-center"}
    (loc/tr :survey-process/localized-labels)
    [:span
     {:class "text-xs text-base-light-text-paler"}
     (loc/tr :this-will-be-visible-for-recipients)]]
   [:ul
    {:class "flex flex-col gap-1"}
    (->> languages
         (map (fn [lng]
                ^{:key (str "Survey-label-" lng)}
                [labelled-input/view
                 {:label     (:label lng)
                  :data-type :data.type/text-simple
                  :value     (get-in survey-process [:survey-process/localized-labels (:value lng)])
                  :on-change (fn [v]
                               (rf/dispatch [::events/set-localized-label (:value lng) v]))}]))
         (doall))]])

(defn show-previous-response-selector
  "TU selector for showing previous response - can be disabled if admin forced a setting"
  [survey-process template]
  (let [admin-setting (or (:survey-template/show-previous-response-setting template)
                          survey-template-schema/show-previous-response-default)
        forced? (some #{admin-setting} [:previous-response/never :previous-response/always])
        current-value (get survey-process :survey-process/show-previous-response?)
        display-value (cond
                        (= admin-setting :previous-response/never) false
                        (= admin-setting :previous-response/always) true
                        (some? current-value) current-value
                        (= admin-setting :previous-response/allow-yes) true
                        (= admin-setting :previous-response/allow-no) false
                        :else true)]
    [:div
     {:class "flex flex-col gap-1"}
     [labelled-input/view
      {:label     (loc/tr :show-previous-response-process)
       :data-type :data.type/boolean
       :value     display-value
       :disabled? forced?
       :on-change (fn [v]
                    (rf/dispatch [::events/set-show-previous-response v]))}]
     [:p
      {:class "text-xs text-base-pale-text mt-1"}
      (if forced?
        (loc/tr :previous-response-admin-forced)
        (loc/tr :show-previous-response-process-help))]]))

(defn view
  []
  (let [survey-process @(rf/subscribe [::sub/survey-process])
        template-options @(rf/subscribe [::sub/template-options])
        language-options @(rf/subscribe [::sub/language-options])
        valid-form? @(rf/subscribe [::sub/valid-template-changes?])
        template @(rf/subscribe [::sub/selected-template])]
    [:div
     {:class "flex flex-col flex-1"}
     [:div
      {:class "flex-1"}
      [:div
       {:class "p-4 flex flex-auto flex-col overflow-auto"}
       [:div
        {:class "p-0 flex flex-col flex-1 container gap-3 max-w-[1024px]"}
        [:h2
         {:class "text-xl font-semibold"}
         (loc/tr :survey-process-config)]
        [:div
         [:ul
          {:class "flex flex-col gap-3"}
          [template-selector survey-process template-options]
          (when template
            [:<>
             [ref-period-selector survey-process template]
             [lang-selector survey-process language-options]
             [label-input language-options survey-process]
             [show-previous-response-selector survey-process template]])]]]]]
     [:div
      {:class "bg-base-light shadow-sm"}
      [:div
       {:class "p-3 mx-auto max-w-[1024px] flex justify-between gap-2"}
       [:div
        {:class "flex gap-3"}
        [components/editor-exit-button]]
       [:div
        {:class "flex gap-3"}
        [components/editor-delete-button false]
        [components/editor-save-button (not valid-form?) [::events/save-template]]]]]]))

